// extracted by mini-css-extract-plugin
export default {"drawer":"SearchDrawer_drawer__wQqBD","drawerHeader":"SearchDrawer_drawerHeader__SN8G4"};